export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20corporate%20office%20building%20with%20glass%20architecture%20and%20blue%20ambient%20lighting%20at%20dusk%2C%20professional%20technology%20company%20headquarters%20with%20sleek%20contemporary%20design%2C%20clean%20minimalist%20facade%20with%20geometric%20patterns%2C%20sophisticated%20business%20environment%20with%20subtle%20illumination%2C%20high-end%20commercial%20real%20estate%20photography%20style%2C%20ultra-wide%20architectural%20shot%20showing%20building%20exterior%20and%20entrance%20area&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="Modern Corporate Office"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 h-full flex items-center px-5 md:px-6 max-w-7xl mx-auto">
        <div className="w-full md:w-3/5">
          <div className="inline-block px-3 py-1.5 md:px-4 md:py-2 rounded-full border border-white/50 backdrop-blur-sm mb-4 md:mb-6">
            <span className="text-white text-xs md:text-sm font-medium whitespace-nowrap">Professional IT & Business Advisory</span>
          </div>

          <h1 className="text-2xl sm:text-3xl md:text-5xl font-light text-white leading-snug md:leading-relaxed mb-5 md:mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
            Empowering Business Through<br className="hidden sm:block" /> Technology & Strategic Insight
          </h1>

          <p className="text-sm md:hidden text-white/80 leading-relaxed mb-6">
            Professional consultancy and IT solutions tailored for your business growth.
          </p>

          <button
            onClick={scrollToContact}
            className="bg-blue-500 text-white px-6 py-3 md:px-8 md:py-3 rounded-full text-sm md:text-base font-medium hover:bg-blue-600 transition-all flex items-center gap-2 whitespace-nowrap"
          >
            Start Your Journey
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}